import React from 'react'
import { useHistory, useLocation } from 'react-router'

import useStyles from './styles'

interface LinkProps {
  to: string
  onClick: () => void
  testid?: string
  children?: React.ReactNode
}
const Link: React.FC<LinkProps> = ({ to, onClick, testid, children }) => {
  const location = useLocation()
  const history = useHistory()

  const active = React.useMemo(() => to === location.pathname, [to, location])

  const classes = useStyles({ active })

  const handleOnClick = React.useCallback(() => {
    onClick && onClick()
    history.push(to)
  }, [onClick, to, history])

  return (
    <div data-testid={testid} onClick={handleOnClick} className={classes.root}>
      {children}
    </div>
  )
}

export default Link
